import { render, staticRenderFns } from "./Part-Like.vue?vue&type=template&id=57b3c85c"
import script from "./Part-Like.vue?vue&type=script&setup=true&lang=js"
export * from "./Part-Like.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b3c85c')) {
      api.createRecord('57b3c85c', component.options)
    } else {
      api.reload('57b3c85c', component.options)
    }
    module.hot.accept("./Part-Like.vue?vue&type=template&id=57b3c85c", function () {
      api.rerender('57b3c85c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/tables/formats/Part-Like.vue"
export default component.exports